// extracted by mini-css-extract-plugin
export default {"marker":"Yo5OKJ","pin":"GeP_Pw","spinner":"N4hAL9","spin":"Yjcy04","label":"zbrQHX","person":"tKnWN9"};